// extracted by mini-css-extract-plugin
export default {"cardHeader":"card-header_cardHeader__wEkXM"};